var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list-item',{attrs:{"slot":"list","title":_vm.$t("modules.bonus.title")},on:{"click":_vm.openBonus},slot:"list"},[_c('f7-icon',{attrs:{"slot":"media","icon":"fal fa-qrcode"},slot:"media"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }